import { Button, ButtonProps, Icon } from '@chakra-ui/react';
import { Table } from '@tanstack/react-table';
import { RiFileExcel2Line } from 'react-icons/ri';

import { exportTableToCsv } from '../../../widgets/table/exportTableToCsv';
import { getColumnLabel } from '../../utils/tableUtils';

export const ExportCsvButton = <T,>({
    table,
    exportName,
    buttonProps,
}: {
    table: Table<T>;
    exportName: string;
    buttonProps?: ButtonProps;
}) => (
    <Button
        leftIcon={<Icon as={RiFileExcel2Line} />}
        variant="outline"
        size="sm"
        {...buttonProps}
        onClick={() =>
            exportTableToCsv({
                table,
                exportName,
                columnHeader: getColumnLabel,
                onlyVisibleColumns: true,
                excludeDisplayCols: true,
                useSortedRows: true,
            })
        }
    >
        Export results
    </Button>
);
